import { Link } from "react-router-dom";
import img from "../assets/images/404.png";
import { useTranslation } from "react-i18next";

function EnDevelopment() {
  const { t } = useTranslation("global");

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center p-4">
      <div className="container mx-auto max-w-4xl">
        <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden p-8 md:p-12">
          {/* Background decorative elements */}
          <div className="absolute -top-20 -right-20 w-40 h-40 rounded-full bg-blue-100 opacity-40 blur-xl"></div>
          <div className="absolute -bottom-20 -left-20 w-40 h-40 rounded-full bg-purple-100 opacity-40 blur-xl"></div>
          
          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8 md:gap-12">
            {/* 404 Text with glass effect */}
            <div className="flex-1 text-center md:text-left">
              <div className="relative">
                <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">404</h1>
                <div className="absolute inset-0 bg-white/30 backdrop-blur-sm rounded-3xl -z-10"></div>
              </div>
              
              <h2 className="text-3xl md:text-4xl font-heading font-semibold text-gray-800 mt-4">
                {t("notFound.title", "Page non trouvée")}
              </h2>
              
              <p className="text-lg text-gray-600 mt-4 max-w-md">
                {t("notFound.message", "La page que vous recherchez n'existe pas.")}
              </p>
              
              <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                <Link
                  to="/"
                  className="bg-blue-600 py-3 px-8 text-base hover:shadow-lg font-text rounded-full text-white font-semibold transition-all hover:scale-105 text-center"
                >
                  {t("notFound.homeButton", "Retour à l'accueil")}
                </Link>
                
                <Link
                  to="/contact"
                  className="font-semibold bg-black text-base flex items-center justify-center py-3 px-8 font-text rounded-full text-white transition-all hover:scale-105"
                >
                  {t("notFound.contactButton", "Nous contacter")}
                </Link>
              </div>
            </div>
            
            {/* 3D Glass Error Card */}
            <div className="flex-1 perspective-1000">
              <div className="transform rotate-6 transition-all duration-300 hover:-translate-y-2 hover:rotate-0">
                <div className="relative h-64 w-full rounded-xl bg-gradient-to-br from-red-500/20 to-red-600/20 backdrop-blur-md border border-white/20 shadow-xl flex flex-col items-center justify-center overflow-hidden">
                  <div className="absolute -top-6 -right-6 w-20 h-20 rounded-full bg-red-500/30 blur-xl"></div>
                  <div className="absolute -bottom-8 -left-8 w-28 h-28 rounded-full bg-orange-600/20 blur-xl"></div>
                  
                  <div className="w-20 h-20 mb-4 flex items-center justify-center bg-red-600/90 text-white rounded-full shadow-lg group-hover:scale-110 transition-transform">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                  </div>
                  <span className="text-xl font-bold text-red-900 mt-2 z-10 text-center w-full">
                    {t("notFound.errorTitle", "Erreur")}
                  </span>
                  <span className="text-sm text-red-800/70 z-10 text-center w-full px-6 mt-2">
                    {t("notFound.errorMessage", "La page demandée est introuvable ou n'existe plus")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EnDevelopment;
